import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'AMENITY' });



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/amenity/handlers.js